// frontend/modules/notification-config/stores/notification-config-store.ts

import { create } from 'zustand';
import { NotificationConfig, NotificationConfigFilters } from '../types/notification-config.types';

/**
 * Store interface for notification configurations
 */
interface NotificationConfigStore {
  // State
  configurations: NotificationConfig[];
  selectedConfiguration: NotificationConfig | null;
  filters: NotificationConfigFilters;
  isEditModalVisible: boolean;
  isTestModalVisible: boolean;
  
  // Actions
  setConfigurations: (configurations: NotificationConfig[]) => void;
  setSelectedConfiguration: (configuration: NotificationConfig | null) => void;
  setFilters: (filters: Partial<NotificationConfigFilters>) => void;
  clearFilters: () => void;
  setEditModalVisible: (visible: boolean) => void;
  setTestModalVisible: (visible: boolean) => void;
}

/**
 * Zustand store for notification configurations
 */
export const useNotificationConfigStore = create<NotificationConfigStore>((set) => ({
  // Initial state
  configurations: [],
  selectedConfiguration: null,
  filters: {
    search: undefined,
    platform: undefined,
    active: undefined
  },
  isEditModalVisible: false,
  isTestModalVisible: false,
  
  // Actions
  setConfigurations: (configurations) => set({ configurations }),
  
  setSelectedConfiguration: (configuration) => set({ selectedConfiguration: configuration }),
  
  setFilters: (filters) => set((state) => ({
    filters: {
      ...state.filters,
      ...filters
    }
  })),
  
  clearFilters: () => set({
    filters: {
      search: undefined,
      platform: undefined,
      active: undefined
    }
  }),
  
  setEditModalVisible: (visible) => set({ isEditModalVisible: visible }),
  
  setTestModalVisible: (visible) => set({ isTestModalVisible: visible })
}));
